{
  "loading": "Inapakia...",
  "error": "Kosa",
  "success": "Imefanikiwa",
  "cancel": "Ghairi",
  "save": "Hifadhi",
  "close": "Funga",
  "yes": "Ndiyo",
  "no": "Hapana",
  "required": "Inahitajika",
  "optional": "Si Lazima",
  "conditional": "Kwa Masharti",
  "submitted": "Imewasilishwa",
  "approved": "Imeidhinishwa",
  "pending": "Inasubiri"
}